import React from 'react';

import { allFilterPages } from '@features/filter/static/filterUtil';
import BlockCategory from '@features/filter/v2/block-suggestions/BlockCategory';
import BlockCreatedBy from '@features/filter/v2/block-suggestions/BlockCreatedBy';
import CollectionMember from '@features/filter/v2/collection/CollectionMember';
import DevelopmentLocation from '@features/filter/v2/collection/DevelopmentLocation';
import MineAndShared from '@features/filter/v2/collection/MineAndShared';
import OfferPrice from '@features/filter/v2/collection/OfferPrice';
import ProductionPrice from '@features/filter/v2/collection/ProductionPrice';
import Season from '@features/filter/v2/collection/Season';
import Status from '@features/filter/v2/collection/Status';
import AccountManager from '@features/filter/v2/core/AccountManager';
import ArtworkPattern from '@features/filter/v2/core/artwork-list/ArtworkPattern';
import Mood from '@features/filter/v2/core/artwork-list/Mood';
import Tag from '@features/filter/v2/core/artwork-list/Tag';
import BlockName from '@features/filter/v2/core/block-library/BlockName';
import CreatedBy from '@features/filter/v2/core/block-library/CreatedBy';
import FittingType from '@features/filter/v2/core/block-library/FittingType';
import Length from '@features/filter/v2/core/block-library/Length';
import Region from '@features/filter/v2/core/block-library/Region';
import RISE from '@features/filter/v2/core/block-library/Rise';
import BrandApprover from '@features/filter/v2/core/BrandApprover';
import Collection from '@features/filter/v2/core/Collection';
import CostingStatus from '@features/filter/v2/core/CostingStatus';
import Department from '@features/filter/v2/core/Department';
import DesignedBy from '@features/filter/v2/core/DesignedBy';
import Overdue from '@features/filter/v2/core/Overdue';
import Placement from '@features/filter/v2/core/Placement';
import ProductCategory from '@features/filter/v2/core/ProductCategory';
import RequestedBy from '@features/filter/v2/core/RequestedBy';
import Brand from '@features/filter/v2/core/Sample/Brand';
import Category from '@features/filter/v2/core/Sample/Category';
import FabricSupplier from '@features/filter/v2/core/Sample/FabricSupplier';
import Market from '@features/filter/v2/core/Sample/Market';
import SampleStatus from '@features/filter/v2/core/Sample/SampleStatus';
import TeamMember from '@features/filter/v2/core/TeamMember';
import Base from '@features/filter/v2/fabric/Base';
import Characteristics from '@features/filter/v2/fabric/Characteristics';
import Color from '@features/filter/v2/fabric/Color';
import Composition from '@features/filter/v2/fabric/Composition';
import Country from '@features/filter/v2/fabric/Country';
import FabricBalance from '@features/filter/v2/fabric/FabricBalance';
import FabricPriceRange from '@features/filter/v2/fabric/FabricPriceRange';
import FabricTypeV2 from '@features/filter/v2/fabric/FabricTypeV2';
import FinishAndWash from '@features/filter/v2/fabric/FinishAndWash';
import ImportedOrLocal from '@features/filter/v2/fabric/ImportedOrLocal';
import NotUsedSince from '@features/filter/v2/fabric/NotUsedSince';
import Weight from '@features/filter/v2/fabric/Weight';
import Designation from '@features/filter/v2/my-colleagues/Designation';
import Stackholder from '@features/filter/v2/my-colleagues/Stackholder';
import TeamLead from '@features/filter/v2/my-colleagues/TeamLead';
import BodyParts from '@features/filter/v2/pom-list/BodyParts';
import PomSize from '@features/filter/v2/pom-list/PomSize';
import PositionList from '@features/filter/v2/pom-list/PositionList';
import Side from '@features/filter/v2/pom-list/Side';
import DateRangeWrapper from '@features/filter/v2/salesFunnel/DateRangeWrapper';
import Probability from '@features/filter/v2/salesFunnel/Probability';
import Stages from '@features/filter/v2/salesFunnel/Stages';
import Audit from '@features/filter/v2/supplier/Audit';
import Certificate from '@features/filter/v2/supplier/Certificate';
import CertificateStrength from '@features/filter/v2/supplier/CertificateStrength';
import FabricType from '@features/filter/v2/supplier/FabricType';
import Location from '@features/filter/v2/supplier/Location';
import PriceRange from '@features/filter/v2/supplier/PriceRange';
import Supplier from '@features/filter/v2/supplier/Supplier';
import SupplierGrade from '@features/filter/v2/supplier/SupplierGrade';
import SupplierStatus from '@features/filter/v2/supplier/SupplierStatus';
import SupplierType from '@features/filter/v2/supplier/SupplierType';
import BrandSpecific from '@features/filter/v2/trims/BrandSpecific';
import MaterialCategory from '@features/filter/v2/trims/MaterialCategory';
import MaterialQuality from '@features/filter/v2/trims/MaterialQuality';
import MultilayerColors from '@features/filter/v2/trims/MultilayerColors';
import Pattern from '@features/filter/v2/trims/Pattern';
import Sustainability from '@features/filter/v2/trims/Sustainability';
import RevenueStream from '@features/filter/v2/order/RevenueStream';
import EntryState from '@features/filter/v2/order/EntryState';
import CommercialInvoiceNumber from '@features/filter/v2/order/CommercialInvoiceNumber';
import TnaStatus from '@features/filter/v2/order/TnaStatus';
import DesignBy from '@features/filter/v2/order/DesignBy';
import Merchandiser from '@features/filter/v2/order/Merchandiser';
import PoNumber from '@features/filter/v2/order/PoNumber';
import OrderTitle from '@features/filter/v2/order/OrderTitle';
import OrderStage from '@features/filter/v2/order/OrderStage';
import SalesContract from '@features/filter/v2/order/SalesContract';
import ProgramType from '@features/filter/v2/order/ProgramType';
import TrendComposition from '@features/filter/v2/trend-research/TrendComposition';
import TrendGraphics from '@features/filter/v2/trend-research/TrendGraphics';
import TrendFiber from '@features/filter/v2/trend-research/TrendFiber';
import TrendAop from '@features/filter/v2/trend-research/TrendAop';
import TrendCategory from '@features/filter/v2/trend-research/TrendCategory';
import TrendBrandCategory from '@features/filter/v2/trend-research/TrendBrandCategory';
import TrendInfluencers from '@features/filter/v2/trend-research/TrendInfluencers';

import CollectionLocation from '@/features/filter/v2/collection/CollectionLocation';
import Date from '@/features/filter/v2/collection/Date';
import Team from '@/features/filter/v2/collection/Team';
import Owner from '@/features/filter/v2/project/owner';
import ProjectType from '@/features/filter/v2/project/ProjectType';
import LastStatus from '@/features/filter/v2/core/LastStatus';
import StyleTraker from '@/features/filter/v2/core/StyleTraker';

const FilterComponent = ({
	filterPageName = '',
	fields,
	showFilter,
	isDependentFilter,
	showScrollBar = true,
	className = ''
}) => {
	const findFilterTypeWiseComponent = (type) => {
		switch (type) {
			case 'supplierGrade':
				return (
					<SupplierGrade isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'supplierType':
				return <SupplierType isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'supplierStatus':
				return (
					<SupplierStatus isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'fabricType':
				return <FabricType isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'location':
				return <Location isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'accountManager':
				return (
					<AccountManager isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'projectManager':
				return (
					<AccountManager
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						titleName="PROJECT_MANAGER"
					/>
				);
			case 'brand':
				return <Brand isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'brandApprover':
				return (
					<BrandApprover isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'costingStatus':
				return (
					<CostingStatus isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'certificate':
				return <Certificate isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'certificateStrength':
				return (
					<CertificateStrength
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
					/>
				);
			case 'audit':
				return <Audit isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'priceRange':
				return <PriceRange isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'dateRange':
			case 'poReceivedDate':
			case 'exFactoryDate':
			case 'buyerEtd':
			case 'factoryEtd':
			case 'soldDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName={
							type === 'poReceivedDate'
								? 'PO_RECEIVED_DATE'
								: type === 'buyerEtd'
									? 'BUYER_ETD'
									: type === 'exFactoryDate'
										? 'EX_FACTORY_DATE'
										: type === 'soldDate'
											? 'SOLD_DATE'
											: type === 'factoryEtd'
												? 'FACTORY_ETD'
												: 'DATE_RANGE'
						}
					/>
				);
			case 'designedBy':
				return <DesignedBy filterPageName={filterPageName} />;
			case 'department':
				return <Department isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'overDue':
				return <Overdue isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'probability':
				return <Probability isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'productCategory':
				return (
					<ProductCategory isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'sampleStatus':
				return <SampleStatus isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'stages':
				return <Stages isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'teamMember':
				return <TeamMember isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'market':
				return <Market isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'category':
				return <Category isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'collection':
				return <Collection isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'supplierList':
				return (
					<Supplier
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName={filterPageName === allFilterPages.COSTING_LIST ? 'SUPPLIER' : 'FACTORY'}
					/>
				);
			case 'fabricSupplierList':
				return (
					<FabricSupplier isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'requestedDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="REQUESTED_DATE"
					/>
				);
			case 'requiredDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="REQUIRED_DATE"
					/>
				);
			case 'submissionPlanDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="SUBMISSION_PLAN_DATE"
					/>
				);
			case 'creationDate':
			case 'soldDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName={filterPageName === 'soldDate' ? 'SOLD_DATE' : 'CREATION_DATE'}
					/>
				);
			case 'projectDueDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="PROJECT_DUE_DATE"
					/>
				);
			case 'publishDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="PUBLISH_DATE"
					/>
				);
			case 'lastModifiedDate':
				return (
					<DateRangeWrapper
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="LAST_MODIFIED_DATE"
					/>
				);
			case 'requestedBy':
				return <RequestedBy filterPageName={filterPageName} />;
			case 'placement':
				return <Placement filterPageName={filterPageName} />;
			case 'bodyParts':
				return <BodyParts filterPageName={filterPageName} />;
			case 'pomSize':
				return <PomSize filterPageName={filterPageName} />;
			case 'side':
				return <Side filterPageName={filterPageName} />;
			case 'verticalOrHorizontal':
				return <PositionList filterPageName={filterPageName} />;
			case 'blockName':
				return <BlockName filterPageName={filterPageName} />;
			case 'fittingType':
				return <FittingType isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'rise':
				return <RISE isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'length':
				return <Length isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'region':
				return <Region isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'createdBy':
				return <CreatedBy isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'mood':
				return <Mood isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'artworkPattern':
				return (
					<ArtworkPattern isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			// case 'color':
			// 	return <Color isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'tag':
				return <Tag isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'blockCreatedBy':
				return <BlockCreatedBy filterPageName={filterPageName} />;
			case 'blockCategory':
				return <BlockCategory filterPageName={filterPageName} />;
			case 'designation':
				return <Designation filterPageName={filterPageName} />;
			case 'stackholder':
				return <Stackholder filterPageName={filterPageName} />;
			case 'teamLead':
				return <TeamLead filterPageName={filterPageName} />;
			case 'base':
				return <Base filterPageName={filterPageName} />;
			case 'color':
				return <Color filterPageName={filterPageName} />;
			case 'composition':
				return <Composition filterPageName={filterPageName} />;
			case 'characteristics':
				return <Characteristics filterPageName={filterPageName} />;
			case 'country':
				return <Country filterPageName={filterPageName} />;
			case 'finishAndWash':
				return <FinishAndWash filterPageName={filterPageName} />;
			case 'importedOrLocal':
				return <ImportedOrLocal filterPageName={filterPageName} />;
			case 'weight':
				return <Weight filterPageName={filterPageName} />;
			case 'fabricTypeV2':
				return <FabricTypeV2 filterPageName={filterPageName} />;
			case 'supplierV2':
				return (
					<Supplier
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterName="SUPPLIER"
					/>
				);
			case 'priceRangeV2':
				return <FabricPriceRange />;
			case 'notUsedSince':
				return <NotUsedSince />;
			case 'fabricBalance':
				return <FabricBalance />;
			case 'season':
				return <Season isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'theme':
				return (
					<Season
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						type="THEME"
					/>
				);
			case 'purpose':
			case 'status':
			case 'PROJECT_STATUS':
			case 'expiry':
				return (
					<Status
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						filterType={type}
					/>
				);
			case 'collectionMember':
				return (
					<CollectionMember isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'developmentLocation':
				return (
					<DevelopmentLocation
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
					/>
				);
			case 'mineAndShared':
				return (
					<MineAndShared isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'productionPrice':
				return (
					<ProductionPrice isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'offerPrice':
				return <OfferPrice isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'materialQuality':
				return (
					<MaterialQuality isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'multilayerColors':
				return (
					<MultilayerColors isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'pattern':
				return <Pattern isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'sustainability':
				return (
					<Sustainability isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'brandSpecific':
				return (
					<BrandSpecific isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'materialCategory':
				return (
					<MaterialCategory isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'date':
				return <Date type="DATE" filterPageName={filterPageName} />;
			case 'team':
				return <Team filterPageName={filterPageName} />;
			case 'collectionLocation':
				return <CollectionLocation filterPageName={filterPageName} />;
			case 'collectionLocationUpdate':
				if (filterPageName === allFilterPages.FAVOURITE_DETAILS) {
					return (
						<Status
							filterPageName="INVENTORY_UPDATE"
							filterType="INVENTORY_UPDATE"
							isDependentFilter={isDependentFilter}
						/>
					);
				}
				return <></>;
			case 'commercialInvoiceNumber':
				return (
					<CommercialInvoiceNumber
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						showFilter={showFilter}
					/>
				);
			case 'tnaStatus':
				return <TnaStatus isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'designBy':
				return <DesignBy isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'merchandiser':
				return <Merchandiser isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'poNumber':
				return (
					<PoNumber
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						showFilter={showFilter}
					/>
				);
			case 'orderTitle':
				return (
					<OrderTitle
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						showFilter={showFilter}
					/>
				);
			case 'orderStage':
				return <OrderStage isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'salesContract':
				return (
					<SalesContract
						isDependentFilter={isDependentFilter}
						filterPageName={filterPageName}
						showFilter={showFilter}
					/>
				);
			case 'revenueStream':
				return (
					<RevenueStream isDependentFilter={isDependentFilter} filterPageName={filterPageName} />
				);
			case 'entryState':
				return <EntryState filterPageName={filterPageName} />;
			case 'owner':
				return <Owner isDependentFilter={isDependentFilter} filterPageName={filterPageName} />;
			case 'trendResearchComposition':
				return <TrendComposition filterPageName={filterPageName} />;
			case 'graphics':
				return <TrendGraphics filterPageName={filterPageName} />;
			case 'fiber':
				return <TrendFiber filterPageName={filterPageName} />;
			case 'aop':
				return <TrendAop filterPageName={filterPageName} />;
			case 'trendCategory':
				return <TrendCategory filterPageName={filterPageName} />;
			case 'brandCategory':
				return <TrendBrandCategory filterPageName={filterPageName} />;
			case 'influencerList':
				return <TrendInfluencers filterPageName={filterPageName} />;
			case 'projectType':
				return <ProjectType filterPageName={filterPageName} isDependentFilter={isDependentFilter} />;
			case 'lastStatus':
				return <LastStatus filterPageName="LAST_STATUS" />;
			case 'styleTracker':
				return <StyleTraker filterPageName="STYLE_TRACKER" />;
			case 'programType':
				return <ProgramType filterPageName={filterPageName} isDependentFilter={isDependentFilter} />;
			default:
				return <></>;
		}
	};

	return (
		<div
			className={`filter-bar-section ${showFilter ? 'open' : ''} ${className}`}
			id="filter-bar-section-id"
			onMouseDown={(e) => e.stopPropagation()}
		>
			<div className="filter-content-v3">
				<div className={` ${showScrollBar ? 'filter-nav scroll-y-label' : 'filter-nav'}`}>
					<ul>
						{Object.keys(fields)?.map((field, index) => (
							<React.Fragment key={`${field}-${index}`}>
								{fields[field] === true ? findFilterTypeWiseComponent(field) : <></>}
							</React.Fragment>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default FilterComponent;
